export default "__VITE_ASSET__CLDWy6sE__"